"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.balanceOfErc721Multiple = void 0;
const BalanceOfABI_json_1 = __importDefault(require("../abi/BalanceOfABI.json"));
const ethers_1 = require("ethers");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const parseBlockTag_1 = require("../utils/parseBlockTag");
/**
 * Calculates `balanceOf` for multiple ERC-721 contracts
 */
const balanceOfErc721Multiple = (addresses, multipliers) => {
    return async (userAddress, _communityAddress, blockTag, provider) => {
        if (multipliers.length !== addresses.length)
            throw new Error('Number of multipliers do not match number of addresses provided.');
        const balances = await Promise.all(addresses.map(async (address) => {
            const contract = new ethers_1.Contract(address, BalanceOfABI_json_1.default, provider);
            const balance = await contract.balanceOf(userAddress, {
                blockTag: (0, parseBlockTag_1.parseBlockTag)(blockTag),
            });
            return new bignumber_js_1.default(balance.toString());
        }));
        return balances
            .reduce((prev, current, index) => prev.plus(current.times(multipliers[index])))
            .toNumber();
    };
};
exports.balanceOfErc721Multiple = balanceOfErc721Multiple;
